import React from 'react';
import { QuestionMark } from 'react-design-components';
import { HelpModal } from 'react-commons';
import { CheckChoiceButton, ChoiceWrapper } from '../Elements';
import { CheckFlowHelp } from '../Help';
import useCheckFlow from './hooks/useCheckFlow';
import { MainLayout } from '../MainLayout';
import { Greeting } from '../Question';

interface Props {
  nextUrl?: Array<string>;
  progress?: number;
}

const CheckFlow: React.FC<Props> = (props: Props) => {
  const { nextUrl, progress } = props;
  const { classes, t, onPrivateClick, onBusinessClick, toggleHelpModal } = useCheckFlow(nextUrl);

  return (
    <MainLayout progress={progress} directAccess t={t} pageTitle="page_title">
      <HelpModal>
        <CheckFlowHelp />
      </HelpModal>
      <div className={classes.alignBottom}>
        <Greeting>
          <QuestionMark onHelpClick={toggleHelpModal} title={t('title')}>
            <ChoiceWrapper>
              <CheckChoiceButton onClick={() => onPrivateClick()}>
                <span className={classes.title}>{t('private')}</span>
              </CheckChoiceButton>
              <CheckChoiceButton onClick={() => onBusinessClick()}>
                <span className={classes.title}>{t('business')}</span>
              </CheckChoiceButton>
            </ChoiceWrapper>
          </QuestionMark>
        </Greeting>
      </div>
    </MainLayout>
  );
};

export default CheckFlow;
